import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import filterComponentState from "./filterComponentState";

const AddRemoveValue = observer(props => {
  const {
    defaultValue = [],
    store = [],
    id = "",
    setTableLoading = () => {}
  } = props || {};

  const [updatedDefaultValue, setUpdatedDefaultValue] = useState(defaultValue);
  // Collapse selected items past the first 3 behind a +N toggle (matches the
  // contact filter tags category).
  const [expandCollapse, setExpandCollapse] = useState(false);

  const onCloseIconClick = item => {
    let tempData = [...filterComponentState?.selectedFilteredList?.[id]];
    const updatedSelectedFilterData = tempData.filter(filterData => {
      return filterData?.id !== item?.id;
    });
    filterComponentState.setSelectedFilteredList({
      ...filterComponentState.selectedFilteredList,
      [id]: updatedSelectedFilterData
    });
    const updatedFilteredData = store?.filterComponentData?.[id].filter(
      filterData => filterData !== item?.id
    );
    store.setFilterComponentData({
      ...store.filterComponentData,
      [id]: updatedFilteredData
    });
  };

  const handleClearAll = () => {
    filterComponentState.setSelectedFilteredList({
      ...filterComponentState.selectedFilteredList,
      [id]: []
    });
    filterComponentState.setFilterComponentData({
      ...filterComponentState.filterComponentData,
      [id]: []
    });
  };

  useEffect(() => {
    setUpdatedDefaultValue(defaultValue);
  }, [defaultValue]);

  return (
    updatedDefaultValue?.length > 0 && (
      <section className="addRemoveValue">
        <span className="horizontalBorderLine" />
        <div className="flexCenterWithJustifyContent">
          <div className="addRemoveValueWrapper">
            <div className="addRemoveValueCont">
              {updatedDefaultValue?.map((item, index) => {
                const value =
                  id === "contactStages"
                    ? item?.displayName
                    : id === "tagIds"
                    ? item?.value
                    : item?.name;
                if (index >= 3 && !expandCollapse) return null;
                return (
                  <div className="tagItem" key={value}>
                    <span className="selectedTag">{value}</span>
                    <i
                      className="material-icons selectedTagCloseIcon"
                      onClick={() => onCloseIconClick(item)}
                    >
                      close
                    </i>
                  </div>
                );
              })}
              {updatedDefaultValue?.length > 3 && (
                <div
                  className="expandCollapse"
                  onClick={() => setExpandCollapse(!expandCollapse)}
                >
                  <span className="count">
                    {expandCollapse
                      ? "less"
                      : `+${updatedDefaultValue.length - 3}`}
                  </span>
                  <i
                    className={`material-icons arrowIcon ${
                      expandCollapse ? "rotate" : ""
                    }`}
                  >
                    keyboard_arrow_down
                  </i>
                </div>
              )}
              {filterComponentState?.selectedFilteredList?.[id]?.length >= 5 &&
                id !== "contactField" && (
                  <div className="maxValueReached">
                    {"Maximum limit reached"}
                  </div>
                )}
            </div>
          </div>

          <div className="resetButton" onClick={handleClearAll}>
            <i className="material-icons refreshIcon">refresh</i>
            <span className="text">Reset</span>
          </div>
        </div>
      </section>
    )
  );
});

export { AddRemoveValue };
export default AddRemoveValue;
